<template>
  <md-card>
    <md-card-header class="md-card-header-icon bg-white">
      <div class="card-icon">
        <md-icon>event</md-icon>
      </div>
      <h4 class="title">{{ event.name }}</h4>
    </md-card-header>

    <md-card-content>
      <md-field>
        <label>Name</label>
        <md-input v-model="event.name"></md-input>
      </md-field>

      <date-range-picker
          :start="event.travel_date_from"
          :end="event.travel_date_to"
          @change="changeTravelDate"
      >
      </date-range-picker>
      
      <div>
        <label>Golden Dates</label>
        <div class="md-layout"
            v-for="(value, index) in golden_days_ranges"
            :key="index">
            <date-range-picker
              :start="value.from"
              :end="value.to"
              :displayList="true"
              :max-months="3"
              :displayFrom="false"
              :displayTo="false"
              displayFromTo
              @change="onDatePickerChange($event, index)"
            >
            </date-range-picker>
          <md-button
              v-if="Math.max(1, golden_days_ranges.length) > 1"
              @click="deleteWindow(index)"
              class="md-white md-just-icon"
          ><md-icon>delete</md-icon></md-button>
          <md-button
              v-if="golden_days_ranges.length == (index + 1)"
              class="md-white md-just-icon"
              @click="addGoldenDate"
          ><md-icon>add</md-icon></md-button>
        </div>
        <md-button
            v-if="golden_days_ranges.length == 0"
            class="md-white md-just-icon md-layout-item"
            @click="addGoldenDate"
        ><md-icon>add</md-icon></md-button>
      </div>
      <div>
        <md-checkbox v-model="event.recurrent" :value="true"
        >Usual event</md-checkbox>
      </div>

      <md-field v-if="event.recurrent">
        <label>Master event</label>
        <md-select v-model="event.event_category_id" @input="setCategory">
          <md-option
            v-for="(category, index) in eventCategories"
            :key="index"
            :value="category.id"
            >{{ category.name }}</md-option
          >
          <md-option value="-1">+ New category</md-option>
        </md-select>
      </md-field>

      <md-field class="md-size">
        <label>Color</label>
        <md-input type="color" v-model="event.color" />
      </md-field>
      <md-list v-if="showBackendLinks">
        <router-link :to="{ name: 'Target' }" class="h6">Target</router-link>
        <router-link :to="{ name: 'Anual Pricing' }" class="h6"
          >Pricing</router-link
        >
      </md-list>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-success" @click="save">Save</md-button>
      <md-button @click="cancel">Cancel</md-button>
      <md-button class="md-danger" @click="deleteEvent">Delete</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import EventApi from "../../openapi/src/api/EventsApi";
import EventCategoryApi from "../../openapi/src/api/EventCategoryApi";
import EventDTO from "../../openapi/src/model/EventDTO";
import DateRangePicker from "@/components/Inputs/DateRangePicker";
import Swal from "sweetalert2";

const api = new EventApi();
const apiEventCategory = new EventCategoryApi();

export default {
  name: "EventFormCard",
  props: {
    value: {
      type: Object
    }
  },
  components: {
    DateRangePicker
  },
  data() {
    return {
      showBackendLinks: false,
      event: {},
      eventCategories: [],
      golden_days_ranges: []
    };
  },
  methods: {
    save() {
      this.setGoldenDays()
      if (this.event.id) {
        api.updateEvent(
          this.$root.hotelId,
          this.event.id,
          EventDTO.constructFromObject(this.event),
          (error, data) => {
            if (!error) {
              this.$emit("saved", this.event);
            }
          }
        );
      } else {
        api.saveEvent(
          this.$root.hotelId,
          EventDTO.constructFromObject(this.event),
          (error, data) => {
            if (!error) this.$emit("saved", this.event);
          }
        );
      }
      this.showBackendLinks = true;
    },
    onDatePickerChange(range, index) {
      this.golden_days_ranges[index] = {
        from: range.start,
        to: range.end
      }
    },
    setGoldenDays() {
      this.event.golden_days = this.golden_days_ranges.filter(e => e.from)
        .filter(e => e.to)
        .flatMap(e => {
        const start = new Date(e.from)
        const end = new Date(e.to)
        var loop = new Date(start)

        const dates = []

        while(loop <= end){      
          const actual = new Date(loop)
          dates.push(actual)  
          var newDate = loop.setDate(loop.getDate() + 1);
          loop = new Date(newDate);
        }

        return dates
      })
    },
    setGoldenDaysRanges() {
      const groupedGoldenDays = []

      var actualGroup = 0
      
      this.event.golden_days.sort((a,b) => {
        return new Date(a) - new Date(b);
      }).forEach((actual, index) => {
          const prev = this.event.golden_days[index - 1]

          if (new Date(new Date(prev).setDate(new Date(prev).getDate() + 1)).toLocaleDateString() !== new Date(actual).toLocaleDateString()) {
            actualGroup++
            groupedGoldenDays[`group${actualGroup}`] = []
          }
          groupedGoldenDays[`group${actualGroup}`].push(actual)
      });

      this.golden_days_ranges = []

      for (const [key, value] of Object.entries(groupedGoldenDays)) {
        const first = value[0]
        const last = value[value.length - 1]
        this.golden_days_ranges.push({
          from: first,
          to: last
        })
      }
    },
    loadFromApi() {
      if (this.value.id) {
        api.getEvent(this.$root.hotelId, this.value.id, (error, data) => {
          if (!error) {
            this.event = data;
            this.setGoldenDaysRanges()
          }
        });
      } else {
        this.event = this.value;
        this.setGoldenDaysRanges()
        this.addGoldenDate()
      }
    },
    setCategory(id) {
      if (id == -1) {
        Swal.fire({
          title: "Create new category",
          html: `<div class="md-field md-theme-default">
        <input type="text" id="md-input" class="md-input">
        </div>`,
          showCancelButton: true,
          customClass: {
            confirmButton: 'md-button md-success',
            cancelButton: 'md-button md-danger'
          },
          buttonsStyling: false
        }).then(result => {
          if (result) {
            var eventTitle = document.getElementById("md-input").value;
            if (!eventTitle) {
              eventTitle = 'No name';
            }
            this.eventCategories = this.eventCategories.filter(c => c.id != 0);
            this.eventCategories.push({
              id: 0,
              name: eventTitle
            });
            this.event.event_category_id = 0;
            this.event.event_category_name = eventTitle;
          } else {
            this.event.event_category_id = null;
          }
        });
      } else if (id > 0){
        this.event.event_category_name = null;
      }
    },
    changeTravelDate(range) {
      this.event.travel_date_from = range.start;
      this.event.travel_date_to = range.end;
    },
    cancel() {
      this.$emit("cancel");
    },
    deleteEvent() {
      if (this.event.id != null) {
        api.deleteEvent(
            this.$root.hotelId,
            this.event.id,
            (error, data) => {
              this.$emit("delete");
        });
      } else {
        this.$emit("delete");
      }
    },
    addGoldenDate() {
      this.golden_days_ranges.push({from: null, to: null})
    },
    deleteWindow(index) {
      this.$delete(this.golden_days_ranges, index);
    }
  },
  created() {
    this.loadFromApi();
    apiEventCategory.getEventCategories(this.$root.hotelId, (error, data) => {
      if (!error) this.eventCategories = data || [];
    });
  },
  watch: {
    value: {
      handler: function() {
        this.loadFromApi();
      }
    }
  }
};
</script>
